import ApiService from "./ApiService";

const ROOT_URL = "/services/onboarding/api/meetingvideo/private";
const TIMEOUT_DURATION = 600000;

const MeetingVideoApi = new ApiService(ROOT_URL, "", {
  download: function (
    ctx,
    processId,
    timestamp,
    onSuccess,
    onError
  ) {
    this.apiGETOctetStream(
      ctx,
      "/" + processId + "/" + timestamp,
      onSuccess,
      onError
    );
  }
}, TIMEOUT_DURATION);

export default MeetingVideoApi;



// WEBPACK FOOTER //
// ./src/service/MeetingVideoService.js